import Alpine from 'alpinejs';
import select from './select';
import selectItem from './select-item';
import dropzone from './dropzone';

document.addEventListener('alpine:init', () => {
  Alpine.data('select', select);
  Alpine.data('selectItem', selectItem);
  Alpine.data('dropzone', dropzone);
});

export default Alpine;
